module.exports = __webpack_public_path__ + "img/Aryan_Headshot.3bc5f1e9.jpg";